import { sanitizers } from '@/utils/formValidation/sanitizers';
import { TextField } from './TextField';

type PhoneNumberFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  className?: string;
};

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  value,
  onChange,
  placeholder,
  error,
  className,
}: PhoneNumberFieldProps) => {
  return (
    <TextField
      value={value}
      onChange={(v) => onChange(sanitizers.phone(v))}
      placeholder={placeholder}
      error={error}
      className={className}
      prefix={
        <>
          <img src="/flagpack-us.svg" alt="US flag" className="w-[22px] h-4 rounded-sm shrink-0" />
          <div className="w-px h-5 bg-[#E5E7EB] shrink-0" />
        </>
      }
    />
  );
};
